import Navbar from "./Navbar";
import Footer from "./Footer";
import { useSEO } from "../hooks/useSEO";
import { Reveal } from "./Reveal";
import FAQSection from "./FAQSection";
import { FAQ_PAGE_FAQS } from "../lib/faqData";

const HERO_IMAGE = "https://framerusercontent.com/images/Pn8z4Y4ThtLO69X5oDtS6MxW0.jpg";

const FAQPage = () => {
  useSEO({
    title: "FAQ | Skope Kitchens",
    description:
      "Answers to the most common questions about Skope Kitchens — our kitchen-as-a-service model, partnership options, locations, quality standards and how to get started.",
    canonical: "https://www.skopekitchens.com/faq",
  });

  return (
    <div className="bg-white min-h-screen text-ink font-body" data-testid="faq-page">
      <Navbar />
      <main>
        <div className="bg-ink bg-blueprint text-white pt-32 lg:pt-40 pb-12 lg:pb-16">
          <div className="max-w-[860px] mx-auto px-6">
            <Reveal>
              <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.35em] text-skope uppercase">
                <span className="w-1.5 h-1.5 rounded-full bg-skope" />
                Skope FAQ
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <h1 className="mt-6 font-display font-bold text-3xl lg:text-5xl tracking-tight leading-[1.1] text-white" data-testid="page-h1">
                Want to know more?
              </h1>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-5 text-white/55 leading-relaxed max-w-xl">
                Every question founders ask us about partnering with Skope Kitchens — answered.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="max-w-[860px] mx-auto px-6">
          <Reveal delay={0.2}>
            <div className="mt-10 border border-ink/10 relative">
              <img src={HERO_IMAGE} alt="Skope Kitchens commercial kitchen" loading="lazy" className="w-full max-h-[380px] object-cover"
                onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }} />
              <div className="absolute -left-px -top-px w-6 h-6 border-l-2 border-t-2 border-skope" />
            </div>
          </Reveal>
        </div>
      </main>
      <FAQSection faqs={FAQ_PAGE_FAQS} idPrefix="faq" intro="" source="faq" />
      <Footer />
    </div>
  );
};

export default FAQPage;
